import React from 'react';
import { Card, Col } from 'react-bootstrap';

type Props = {
  title: string;
  text: string;
  footer: string;
  onClick?: (newWindow?: boolean) => void;
};

export const ReportCardMenu: React.FC<Props> = ({
  title,
  text,
  footer,
  onClick,
}) => {
  const handleMouseDown = (event: React.MouseEvent) => {
    if (event.button === 1) {
      event.preventDefault();
      event.stopPropagation();

      if (onClick) {
        onClick(true);
      }
    }
  };

  return (
    <Col style={{ display: 'flex' }}>
      <Card
        onClick={() => onClick && onClick()}
        onMouseDown={event => handleMouseDown(event)}
        style={
          onClick ? { cursor: 'pointer', width: '100%' } : { width: '100%' }
        }
      >
        <Card.Body>
          <Card.Title>{title}</Card.Title>

          <Card.Text>{text}</Card.Text>
        </Card.Body>
        <Card.Footer>
          <small className="text-muted">{footer}</small>
        </Card.Footer>
      </Card>
    </Col>
  );
};
